// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1ke2U","messages":"Chat_messages__2jifF","dateDivider":"Chat_dateDivider__O3-QA"};